import * as React from 'react';
import {Text, View} from 'react-native';
import {Screens} from '../../../../../routing';
import {Link} from '../../../../link';
import {CardBlockedMessageViewProps} from '../model';

const CardBlockedMessageDesktop = ({
  canReissueCard,
  showReissueHintBelow,
  navigate,
  styles,
}: CardBlockedMessageViewProps) => {
  if (!canReissueCard) {
    return (
      <Text style={[styles.message, styles.messageWithIconGap]} testID='notification-card-blocked-title'>
        Ваша карта заблокирована. Обратитесь в ближайшее отделение для перевыпуска или позвоните в техподдержку.
      </Text>
    );
  }

  if (showReissueHintBelow) {
    return (
      <Text style={[styles.message, styles.messageWithIconGap]} testID='notification-card-blocked-title'>
        Ваша карта заблокирована. Ознакомьтесь со способами её перевыпуска ниже.
      </Text>
    );
  }

  return (
    <View style={styles.messageRow} testID='notification-card-blocked-title'>
      <Text style={styles.message}>Ваша карта заблокирована. Вы можете </Text>
      <Link
        testID='notification-card-blocked-reissue-link'
        screen={Screens.Profile}
        navigate={navigate}
        textStyle={styles.link}>
        перевыпустить ЕСК
      </Link>
      <Text style={styles.message}> самостоятельно или обратиться в ближайший центр выпуска</Text>
    </View>
  );
};

export default CardBlockedMessageDesktop;
